import { UserPreferences } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<UserPreferences>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const userPreferencesByEmailReducer = createReducer<State, Actions>(initialState, {
  [actions.getUserPreferencesByEmail.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getUserPreferencesByEmail.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getUserPreferencesByEmail.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.partialUpdateUserPreferencesByEmail.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.partialUpdateUserPreferencesByEmail.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.partialUpdateUserPreferencesByEmail.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.partialUpdateUserPreferencesByEmail.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default userPreferencesByEmailReducer;
